(() => {
  function isTryOnPage() {
    const el = document.querySelector('product-rerender[data-tryon="true"]');
    return !!el;
  }

  function getBuyButtonsRoot() {
    // Prestige uses <buy-buttons class="buy-buttons"> inside the product form
    return document.querySelector('product-rerender buy-buttons.buy-buttons') ||
           document.querySelector('buy-buttons.buy-buttons') ||
           document.querySelector('.product-info buy-buttons.buy-buttons') ||
           document.querySelector('.product-info .buy-buttons');
  }

  function hasButton(root) {
    if (!root) return false;
    return !!root.querySelector('button[type="submit"], button[name="add"], .shopify-payment-button');
  }

  function cache(root) {
    if (!root || root.dataset.tryonCached === "1") return;
    root.dataset.tryonCached = "1";
    root.dataset.tryonHtml = root.innerHTML;
  }

  function restore() {
    if (!isTryOnPage()) return;

    const root = getBuyButtonsRoot();
    if (!root) return;

    cache(root);

    // If the button disappears after swatch selection, restore it
    if (!hasButton(root) && root.dataset.tryonHtml) {
      root.innerHTML = root.dataset.tryonHtml;
    }
  }

  function hook() {
    // Run on load
    setTimeout(restore, 50);
    setTimeout(restore, 250);

    // Run after variant / swatch changes
    document.addEventListener("change", (e) => {
      const t = e.target;
      if (!t) return;

      const isVariantThing =
        t.matches('input[name^="options["], select[name^="options["], input[type="radio"]') ||
        t.closest('.variant-picker') ||
        t.closest('[data-option]') ||
        t.closest('[data-swatch]');

      if (!isVariantThing) return;

      setTimeout(restore, 50);
      setTimeout(restore, 250);
    }, true);

    // Apps sometimes remove nodes after render
    new MutationObserver(() => restore()).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener("DOMContentLoaded", hook);
  document.addEventListener("shopify:section:load", hook);
})();

(() => {
  function isTryOnPage() {
    return !!document.querySelector('product-rerender[data-tryon="true"]');
  }

  function fixTryonButton() {
    if (!isTryOnPage()) return;

    const root = document.querySelector('product-rerender[data-tryon="true"]');
    if (!root) return;

    const btn = root.querySelector('tryon-button');
    if (!btn) return;

    // Force visible
    btn.style.display = "flex";
    btn.style.visibility = "visible";
    btn.style.opacity = "1";
    btn.hidden = false;

    // The big one: Tryon is ending up disabled after variant changes
    if (btn.getAttribute("disabled") === "true" || btn.hasAttribute("disabled")) {
      btn.removeAttribute("disabled");
      btn.setAttribute("aria-disabled", "false");
    }

    // Nudge: some web components re-render on attribute change
    // Re-apply selling plan attr to trigger internal update if present
    const sp = btn.getAttribute("data-selling_plan_id") || btn.getAttribute("data-selling-plan-id");
    if (sp) {
      btn.setAttribute("data-selling_plan_id", sp);
    }
  }

  function scheduleFixes() {
    // Run multiple times because Prestige + apps update async
    [0, 50, 150, 300, 600, 1000].forEach((ms) => setTimeout(fixTryonButton, ms));
  }

  document.addEventListener("DOMContentLoaded", scheduleFixes);

  // On swatch/variant changes
  document.addEventListener(
    "change",
    (e) => {
      const t = e.target;
      if (!t) return;

      const isVariantControl =
        t.matches('input[name^="options["], select[name^="options["], input[type="radio"]') ||
        t.closest(".variant-picker") ||
        t.closest('[data-option]') ||
        t.closest('[data-swatch]');

      if (!isVariantControl) return;

      scheduleFixes();
    },
    true
  );

  // If the DOM changes (rerender), try again
  new MutationObserver(() => scheduleFixes()).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

(() => {
  function isTryOnPage() {
    return !!document.querySelector('product-rerender[data-tryon="true"]');
  }

  function fixTryon() {
    if (!isTryOnPage()) return;

    const root = document.querySelector('product-rerender[data-tryon="true"]');
    const tbtn = root?.querySelector('tryon-button');
    if (!tbtn) return;

    // Ensure visible
    tbtn.style.display = "flex";
    tbtn.style.visibility = "visible";
    tbtn.style.opacity = "1";
    tbtn.hidden = false;

    // If Tryon gets disabled after variant change, re-enable it
    if (tbtn.hasAttribute("disabled") || tbtn.getAttribute("disabled") === "true") {
      tbtn.removeAttribute("disabled");
      tbtn.setAttribute("aria-disabled", "false");
    }
  }

  function schedule() {
    [0, 50, 150, 300, 600, 1000].forEach(ms => setTimeout(fixTryon, ms));
  }

  document.addEventListener("DOMContentLoaded", schedule);

  document.addEventListener("change", (e) => {
    const t = e.target;
    if (!t) return;

    const isVariantControl =
      t.matches('input[name^="options["], select[name^="options["], input[type="radio"]') ||
      t.closest(".variant-picker") ||
      t.closest('[data-option]') ||
      t.closest('[data-swatch]');

    if (!isVariantControl) return;
    schedule();
  }, true);

  new MutationObserver(() => schedule()).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  function updateTryonMaxText() {
    document.querySelectorAll(".tryon-selling-plan-name-span").forEach(function (span) {
      if (span.textContent.trim() === "Reached the maximum Tryon items") {
        span.textContent = "Reached the maximum Try-On items";
      }
    });
  }

  updateTryonMaxText();

  const observer = new MutationObserver(updateTryonMaxText);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
});

document.addEventListener("DOMContentLoaded", function () {
  function updateTryonGuideText() {
    document.querySelectorAll("*").forEach(function (el) {
      el.childNodes.forEach(function (node) {
        if (
          node.nodeType === Node.TEXT_NODE &&
          node.textContent.trim() === "Try at home, pay for what you keep"
        ) {
          node.textContent = "HOME TRIAL GUIDE";
        }
      });
    });
  }

  updateTryonGuideText();

  const observer = new MutationObserver(updateTryonGuideText);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
});

